import { Pipe, PipeTransform } from '@angular/core';
import { CountriesService } from '../services/countries.service';

@Pipe({
    name: 'countryName',
    standalone: true
})
export class CountryNamePipe implements PipeTransform {

    constructor(private country: CountriesService) {
    }

    transform(value: unknown, ...args: unknown[]): string {
        if (value === undefined || value === null) {
            return '';
        }
        return this.country.countryName(value as string);
    }

}
